import React from 'react';
import { SevaSethuFooter } from '../../components';

// Seva Sethu custom footer - replaces hosted assets footer
const FooterComponent = () => {
  return <SevaSethuFooter />;
};

export default FooterComponent;
